import { sendToTerminal } from '../lib/terminalLogger';

export function isAbsoluteWindowsPath(input: string | null | undefined): boolean {
  if (!input || typeof input !== 'string') return false;
  const p = input.trim();
  return /^([a-zA-Z]:\\|\\\\)/.test(p);
}

export function normalizeWindowsPath(input: string | null | undefined): string {
  try {
    if (!input || typeof input !== 'string') return '';
    let p = input.trim();
    // Preferir barra invertida
    p = p.replace(/\//g, '\\');

    // Preservar prefixo UNC (\\server\share)
    const isUnc = p.startsWith('\\\\');
    // Colapsar separadores duplicados
    p = p.replace(/\\{2,}/g, '\\');
    if (isUnc) {
      // Garantir ao menos duas barras no início
      p = '\\' + p; // após colapso acima, isto reconstroi \\ no início
      if (!p.startsWith('\\\\')) p = '\\' + p; // dupla garantia
    }

    // Remover aspas envoltórias
    if ((p.startsWith('"') && p.endsWith('"')) || (p.startsWith("'") && p.endsWith("'"))) {
      p = p.substring(1, p.length - 1);
    }

    // Avisar se conter variáveis de ambiente
    if (/%[^%]+%/.test(p)) {
      try { sendToTerminal('⚠️ [PATH] Variável de ambiente detectada em caminho; evite enviar para WebView', { path: p }); } catch {}
    }

    // Avisar se não for absoluto
    if (!isAbsoluteWindowsPath(p)) {
      try { sendToTerminal('⚠️ [PATH] Caminho não absoluto detectado', { path: p }); } catch {}
    }

    // Avisar se muito longo
    if (p.length > 240) {
      try { sendToTerminal('⚠️ [PATH] Caminho acima de 240 caracteres (recomendação)', { length: p.length }); } catch {}
    }

    return p;
  } catch {
    return String(input || '');
  }
}


